export type EventType = 'audiencia' | 'sessao' | 'prazo' | 'reuniao' | 'outro';

export const eventTypeColors: Record<EventType, { label: string; color: string }> = {
  audiencia: { label: 'Audiência', color: '#7A2430' },
  sessao: { label: 'Sessão de julgamento', color: '#9333EA' },
  prazo: { label: 'Prazo', color: '#F59E0B' },
  reuniao: { label: 'Reunião', color: '#3B82F6' },
  outro: { label: 'Outro', color: '#8B5CF6' },
};

/** Cor padrão para tipos de evento desconhecidos. */
export const EVENT_FALLBACK_COLOR = '#8B5CF6';
